import { useState } from "react";

const TradingCalculatorContentSix = () => {
  const [openIndex, setOpenIndex] = useState(null);

  const toggleSection = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  const sections = [
    {
      title: "What does the Trading Calculator do?",
      text: `It helps you calculate potential profit, loss, margin, and pip value before placing a trade.`,
    },
    {
      title: "Can I use the calculator for all instruments?",
      text: `Yes, it supports Forex, Crypto, Stocks, and other major markets available on The Pips platform.`,
    },
    {
      title: "Do I need a Pips account to access it?",
      text: `You can use it for free, but logging in provides access to saved preferences and account-specific data.`,
    },
    {
      title: "How accurate are the calculations?",
      text: `The calculator uses real-time market data for high-precision results, but actual outcomes may vary slightly due to market volatility.`,
    },
    {
      title: "Can beginners use the Trading Calculator?",
      text: `Absolutely. It’s built to be intuitive and easy to understand, even for first-time traders.`,
    },
    {
      title: "Does it include leverage calculations?",
      text: `Yes. You can select different leverage levels to see how it impacts your required margin and risk.`,
    },
    // {
    //   title: "Is it available on mobile?",
    //   text: `Yes, you can access The Pips Trading Calculator through our mobile app or web browser.`,
    // },
  ];

  return (
    <div className="how__work__resource">
      <div className="container">
        <div className="row">
          {/* LEFT SIDE IMAGE + TEXT */}
          <div className="col-lg-6 col-md-12 col-sm-12 col-12">
            <div className="content-left">
              <h2>Why Every Trader Needs a Calculator</h2>
              <p>
                Even the most experienced traders know that success is in the
                details. The Pips Trading Calculator simplifies complex math,
                ensuring accuracy and clarity at every step, so you can focus on
                executing strategies instead of crunching numbers.
              </p>
            </div>
            <div className="thumb-left">
              <img
                src={process.env.PUBLIC_URL + "/images/resources/trading_calculator/trading_calculator_4.png"}
                alt="computer images"
              />
            </div>
          </div>

          {/* RIGHT SIDE ACCORDION */}
          <div className="col-lg-6 col-md-12 col-sm-12 col-12 sm__mt--40 md__mt--40">
            <div className="content-right">
              <hr className="black-line" />
              {sections.map((section, index) => (
                <div key={index} className="accordion-section">
                  <button
                    className="accordion-header"
                    onClick={() => toggleSection(index)}
                  >
                    <h3>{section.title}</h3>
                    <span
                      className={`arrow ${openIndex === index ? "open" : ""}`}
                    >
                      ▼
                    </span>
                  </button>

                  <div
                    className={`accordion-content ${
                      openIndex === index ? "show" : ""
                    }`}
                  >
                    <p>{section.text}</p>
                  </div>

                  <hr className="black-line" />
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TradingCalculatorContentSix;
